import { appCode } from '../../config';

const SurveyListPage = r => require.ensure([], () => r(require('@/views/survey-list-page')), 'SurveyListPage');
const EditSurveyPage = r => require.ensure([], () => r(require('@/views/edit-survey-page')), 'EditSurveyPage');


export default [
  {
    path: '/as/agent-surveys',
    name: 'agentSurveys',
    components: { as: SurveyListPage },
  },
  {
    path: '/as/agent-surveys/:surveyId',
    name: 'agentSurveys/surveyId',
    components: { as: EditSurveyPage },
    props: { default: true, as: true },
  },
  {
    path: '/as/*',
    name: 'default',
    redirect: { path: `/${appCode}/agent-surveys` },
  },
];
